/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromptsListResponse } from '../../models/prompts-list-response';

export interface PromptsPromosGet$Params {
  page: number;
}

export function promptsPromosGet(
  http: HttpClient,
  rootUrl: string,
  params: PromptsPromosGet$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<PromptsListResponse>> {
  const rb = new RequestBuilder(rootUrl, promptsPromosGet.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PromptsListResponse>;
      }),
    );
}

promptsPromosGet.PATH = '/prompts/promos';
